import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500"></i>
              </div>
              <span className="text-base font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫阅读
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费无删减韩国漫画在线阅读平台，提供海量高质量韩漫资源，支持便捷的下拉式浏览，让您畅享最纯粹的漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="hover:text-primary-500 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">动作漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">悬疑漫画</Link></li>
              <li><Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">剧情漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-links" className="hover:text-primary-500 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">漫画大全</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@hanman.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-xs"></i>
                </div>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫阅读 HanManYueDu. 本站所有漫画资源均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}